/* eslint-disable */
import React from 'react';

function Table(props) {
	return (
		<div className="">
			{props.children}
		</div>
	)
}

export default Table;